import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class TokensBrowserService {
    public constructor(@Inject(DOCUMENT) private readonly document: Document) {}

    public formatSpacing(input: string): string {
        if (!input) {
            return '';
        }

        return input.replace(/\s+/g, ' ').trim();
    }

    public setFocusOnActiveInput(element: string): void {
        if (!!element) {
            const inputField: HTMLElement = this.document.querySelector(element);
            if (inputField != null) {
                setTimeout(() => inputField.focus(), 0);
            }
        }
    }
}
